import { render } from "./ControlIcon.vue?vue&type=template&id=24ac5fd2"
import script from "./ControlIcon.vue?vue&type=script&lang=js"
export * from "./ControlIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__